import React from 'react';
import ReactDOM from 'react-dom';
import reportWebVitals from './reportWebVitals';
import './index.css';
// redux
import { compose, createStore } from "redux";
import persistState from "redux-localstorage";
import { Provider } from "react-redux";
import App from "./App";
import rootReducer from "./reducers"

const enhancer = compose(persistState());
const store = createStore(rootReducer, enhancer);

store.subscribe(() => {
  console.log(store.getState());
});

ReactDOM.render(
  <Provider store={store}>
    {/* <meta name="viewport" content="width=device-width, initial-scale=1"></meta> */}
    <App />
  </Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

export default store;
